import React, { Component } from "react";
import JapaneseLearningContent from "../function-components/Learning/JapaneseLearningContent";

class JapaneseLearning extends Component {
  render() {
    return (
      <>
        <JapaneseLearningContent />
      </>
    );
  }
}

export default JapaneseLearning;
